import { MessageKind } from '../utils/common';
import { notifications } from '@mantine/notifications';

export function createToast(message: string, kind: MessageKind) {
  if(typeof message !== 'string'){
    console.error(message)
    message = "Unknown error"
  }

  notifications.show({
    title: 'Calensync',
    message: message,
    color: kind === MessageKind.Error ? 'red' : kind === MessageKind.Success ? 'green' : 'blue',
    autoClose: 3000,
    position: 'top-right',
  });
}